import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { SlicePlaneProps, SliceCenterlinePlane_$reflection, SliceValues_$reflection } from "./SlicePlaneBindings.js";
import { record_type, tuple_type, array_type, union_type, int32_type, option_type, class_type, bool_type, float64_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { DicomViewMode_$reflection } from "../Common/CommonTypes.js";
import { Visualization_UnifiedBranch_$reflection } from "../../RAWMap.Models/Common.js";

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GotSliceValue", "IncrementSliceIndex", "SetIsHovering", "SetIsDisabled", "SetIsVisible", "SetDicomViewMode", "IncrementCenterlineIndex"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.SlicePlane.Types.InboundMsg", [], InboundMsg, () => [[["Item", SliceValues_$reflection()]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item1", DicomViewMode_$reflection()], ["Item2", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))], ["maybeIndex", option_type(int32_type)]], [["Item", float64_type]]]);
}

export class LocalMsg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SetIsVisible"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.SlicePlane.Types.LocalMsg", [], LocalMsg, () => [[["Item", bool_type]]]);
}

export class OutboundMsg {
    constructor() {
    }
}

export function OutboundMsg_$reflection() {
    return class_type("RAWMap.Client.Visualization.SlicePlane.Types.OutboundMsg", undefined, OutboundMsg);
}

export class ModelSlicePlane extends Record {
    constructor(Index, MaxIndex, IsVisible, IsHovering, IsDisabled, Bounds, DicomViewMode, MaybeCenterlinePlane, MaybeMeshes, MaybeUnifiedBranchIndex) {
        super();
        this.Index = Index;
        this.MaxIndex = MaxIndex;
        this.IsVisible = IsVisible;
        this.IsHovering = IsHovering;
        this.IsDisabled = IsDisabled;
        this.Bounds = Bounds;
        this.DicomViewMode = DicomViewMode;
        this.MaybeCenterlinePlane = MaybeCenterlinePlane;
        this.MaybeMeshes = MaybeMeshes;
        this.MaybeUnifiedBranchIndex = MaybeUnifiedBranchIndex;
    }
}

export function ModelSlicePlane_$reflection() {
    return record_type("RAWMap.Client.Visualization.SlicePlane.Types.ModelSlicePlane", [], ModelSlicePlane, () => [["Index", option_type(float64_type)], ["MaxIndex", option_type(float64_type)], ["IsVisible", bool_type], ["IsHovering", bool_type], ["IsDisabled", bool_type], ["Bounds", option_type(array_type(float64_type))], ["DicomViewMode", DicomViewMode_$reflection()], ["MaybeCenterlinePlane", option_type(SliceCenterlinePlane_$reflection())], ["MaybeMeshes", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))], ["MaybeUnifiedBranchIndex", option_type(tuple_type(Visualization_UnifiedBranch_$reflection(), int32_type))]]);
}

export function ModelSlicePlane_Props_Z714BB56C(x) {
    return new SlicePlaneProps(x.Index, x.MaxIndex, x.Bounds, x.IsVisible ? true : x.IsHovering, x.IsDisabled, x.MaybeCenterlinePlane, x.DicomViewMode);
}

